import { ApolloError } from "@apollo/client";
import { useMemo } from "react";
import {
    ReportVulnerabilityRetestRequestListFieldsFragment,
    useReportVulnerabilityRetestRequestsQuery,
} from "app/api/graph/types";
import { reportVulnerabilityGraphId } from "app/api/graph/helpers";
import { mapNodes } from "app/util/graph";
import { useFetchAll } from "app/api/graph/hook/use-fetch-all";

type Result = {
    retestRequests?: ReportVulnerabilityRetestRequestListFieldsFragment[];
    loading: boolean;
    error?: ApolloError;
};

export const useReportVulnerabilityRetestRequests = (vulnerabilityId: number): Result => {
    const { data, loading, error, fetchMore } = useReportVulnerabilityRetestRequestsQuery({
        variables: { vulnerabilityId: reportVulnerabilityGraphId(vulnerabilityId), order: { createdAt: "DESC" } },
        notifyOnNetworkStatusChange: true,
    });
    const retestRequests = data?.reportVulnerability?.retestRequests;
    const pageInfo = data?.reportVulnerability?.retestRequests?.pageInfo;
    useFetchAll({ loading, pageInfo, fetchMore });

    return useMemo(
        () => ({ retestRequests: mapNodes(retestRequests, (n) => n), loading, error }),
        [retestRequests, loading, error],
    );
};
